module.exports = __webpack_public_path__ + "static/media/tick-orange-icn.85fe9ad7.svg";